import { BrowserModule } from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';

import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import {HttpModule, XHRBackend} from '@angular/http';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ModalComponent} from './components/modal/modal.component';
import {ModalSimpleComponent} from './components/model-simple/modal-simple.component';
import {SharedValueService} from './services/shared-value.service';
import {DialogService} from './services/dialog.service';
import {BackendService} from './services/backend.service';
import {EventService} from './services/event.service';
import {FullCalendarModule} from 'ng-fullcalendar';
import { ModalEventComponent } from './components/modal-event/modal-event.component';
import { DateInputComponent } from './components/date-input/date-input.component';
import {ClickOutsideModule} from 'ng-click-outside';
import {Helper} from './common/helper';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import {AuthenticationService} from './services/authentication.service';
import {PreLoginService} from './services/pre-login.service';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { LogoutPageComponent } from './pages/logout-page/logout-page.component';
import {NotifierModule, NotifierOptions} from 'angular-notifier';
import { ModalActionButtonsComponent } from './components/modal-action-buttons/modal-action-buttons.component';
import { RoomGroupPageComponent } from './pages/room-group-page/room-group-page.component';
import {RoomService} from './services/room.service';
import {GroupService} from './services/group.service';
import {UserService} from './services/user.service';
import { UserPageComponent } from './pages/user-page/user-page.component';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { SiteFooterComponent } from './layouts/site-footer/site-footer.component';
import { SiteHeaderComponent } from './layouts/site-header/site-header.component';
import { SiteLayoutComponent } from './layouts/site-layout/site-layout.component';
import { LeftSidemenuComponent } from './layouts/left-sidemenu/left-sidemenu.component';
import {AppRouting, CanActivateViaAuthGuard} from './app.routing';
import { ModalUserComponent } from './components/modal-user/modal-user.component';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import { ModalChangePasswordComponent } from './components/modal-change-password/modal-change-password.component';
import { ModalProfileComponent } from './components/modal-profile/modal-profile.component';
import { FaceIconComponent } from './components/face-icon/face-icon.component';
import { FaceIconSetComponent } from './components/face-icon-set/face-icon-set.component';
import { ImageCropperComponent } from './components/image-cropper/image-cropper.component';
import { ModalCropperComponent } from './components/modal-cropper/modal-cropper.component';
import {Select2Module} from 'ng2-select2';
import {AuthInterceptor} from './common/interceptor/auth.interceptor';
import {RefreshTokenInterceptor} from './common/interceptor/refreshToken.interceptor';
import {ModalRoomGroupComponent} from './components/modal-room-group/modal-room-group.component';
import {HistoryBookingPageComponent} from './pages/history-booking-page/history-booking-page.component';
import {Angular2Csv} from 'angular2-csv';
import {SiteService} from './services/site.service';

/**
 * Backend factory.
 */
export function createBackend(http: HttpClient, auth: AuthenticationService) {
  return new BackendService(http, auth);
}
/**
 * Custom angular notifier options
 */
const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 12
    },
    vertical: {
      position: 'top',
      distance: 12,
      gap: 10
    }
  },
  theme: 'material',
  behaviour: {
    autoHide: 3000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 5
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ModalComponent,
    ModalSimpleComponent,
    ModalEventComponent,
    DateInputComponent,
    LoginPageComponent,
    LeftSidemenuComponent,
    NotFoundPageComponent,
    LogoutPageComponent,
    ModalActionButtonsComponent,
    RoomGroupPageComponent,
    ModalRoomGroupComponent,
    UserPageComponent,
    AppLayoutComponent,
    SiteFooterComponent,
    SiteHeaderComponent,
    SiteLayoutComponent,
    LeftSidemenuComponent,
    ModalUserComponent,
    ModalChangePasswordComponent,
    ModalProfileComponent,
    FaceIconComponent,
    FaceIconSetComponent,
    ImageCropperComponent,
    ModalCropperComponent,
    HistoryBookingPageComponent,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    AppRouting,
    FormsModule,
    ReactiveFormsModule,
    NgbModule.forRoot(),
    FullCalendarModule,
    ClickOutsideModule,
    NotifierModule.withConfig(customNotifierOptions),
    NgxDatatableModule,
    Select2Module
  ],
  providers: [
    BackendService,
    EventService,
    XHRBackend,
    CanActivateViaAuthGuard,
    {
      provide: BackendService,
      useFactory: (createBackend),
      deps: [HttpClient, AuthenticationService]
    },
    // Provide the Authentication interceptor
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    // Provide the RefreshToken interceptor
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true
    },
    AuthenticationService,
    PreLoginService,
    SharedValueService,
    Helper,
    DialogService,
    RoomService,
    GroupService,
    UserService,
    SiteService,
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class AppModule { }



// WEBPACK FOOTER //
// /app/src/app/app.module.ts